"use strict";import{ProgressBar as r}from"./src/ProgressBar.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-progress-bar",r);
//# sourceMappingURL=sp-progress-bar.js.map
